/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { RenderSections } from '@components/UI/Common/SectionCommonUI';

/**
 * Renders the Volunteer Common UI component.
 * @param {Array} pageBody - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @returns {ReactElement} Volunteer Common UI Component.
 */
const VolunteerCommonUI = ({ pageBody, region, lang, pageName }) => {
  return (
    <Box
      as="section"
      id="centers-section"
      className="container-article btn-center"
    >
      {pageBody && pageBody.length
        ? pageBody.map((section, i) => {
          return (
            <RenderSections
              section={section}
              region={region}
              lang={lang}
              pType="volunteer"
              key={i}
              pageName={pageName}
            />
          );
        })
        : null}
    </Box>
  );
};

export default VolunteerCommonUI;
